import { baseApi } from "@/app/store/api/baseApi";

export interface InAppNotification {
  id: number;
  subject: string;
  body: string;
  sent_at: string | null;
  read_at: string | null;
  template_slug?: string;
}

export interface InAppFeed {
  results: InAppNotification[];
  unread_count: number;
}

const emptyFeed: InAppFeed = { results: [], unread_count: 0 };

export const inAppNotificationsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listInAppNotifications: build.query<InAppFeed, void>({
      query: () => "/notifications/in-app/",
      transformResponse: (r: Partial<InAppFeed> | null) => ({
        results: Array.isArray(r?.results) ? r.results : [],
        unread_count: typeof r?.unread_count === "number" ? r.unread_count : 0,
      }),
    }),
    markInAppNotificationRead: build.mutation<InAppNotification, number>({
      query: (id) => ({ url: `/notifications/in-app/${id}/read/`, method: "POST" }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        const patch = dispatch(
          inAppNotificationsApi.util.updateQueryData("listInAppNotifications", undefined, (draft) => {
            const row = draft.results.find((item) => item.id === id);
            if (row && !row.read_at) {
              row.read_at = new Date().toISOString();
              draft.unread_count = Math.max(0, draft.unread_count - 1);
            }
          }),
        );
        try {
          await queryFulfilled;
        } catch {
          patch.undo();
        }
      },
    }),
    markAllInAppNotificationsRead: build.mutation<{ updated: number }, void>({
      query: () => ({ url: "/notifications/in-app/read-all/", method: "POST" }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        const patch = dispatch(
          inAppNotificationsApi.util.updateQueryData("listInAppNotifications", undefined, (draft) => {
            const now = new Date().toISOString();
            draft.results.forEach((row) => {
              if (!row.read_at) row.read_at = now;
            });
            draft.unread_count = 0;
          }),
        );
        try {
          await queryFulfilled;
        } catch {
          patch.undo();
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useListInAppNotificationsQuery,
  useMarkInAppNotificationReadMutation,
  useMarkAllInAppNotificationsReadMutation,
} = inAppNotificationsApi;

export { emptyFeed };
